import {
    Breadcrumb as BaseBreadcrumb,
    IBreadcrumbItem,
    IBreadcrumbProps,
    IBreadcrumbStyles,
    Shimmer,
    Stack
} from "@fluentui/react";
import React from "react";

export interface BreadcrumbItem extends IBreadcrumbItem {
    tooltipContent?: JSX.Element;
    maxTextLength?: number;
}

export interface BreadcrumbProps
    extends Pick<IBreadcrumbProps, "maxDisplayedItems" | "overflowIndex" | "styles" | "items" | "onRenderItem"> {
    isLoading?: boolean;
    testId?: string;
}

export const Breadcrumb: React.FunctionComponent<BreadcrumbProps> = (props: BreadcrumbProps) => {
    const { items, styles, maxDisplayedItems, overflowIndex, isLoading, onRenderItem, testId } = props;
    const displayItems = items.map((item: BreadcrumbItem) => {
        const maxTextLength = item.maxTextLength || 80;

        if (item.text.length < maxTextLength) {
            return item;
        }

        return {
            ...item,
            text: limitTextLength(item.text, maxTextLength)
        };
    });

    const maxDisplayedItemsValue = maxDisplayedItems || 6;
    const overflowIndexValue = overflowIndex || 2;

    const displayItemsCount =
        displayItems.length > maxDisplayedItemsValue ? displayItems.length : maxDisplayedItemsValue;

    return (
        <Stack styles={{ root: { width: "100%" } }} data-testid={testId}>
            {isLoading ? (
                <Shimmer styles={{ root: { width: `${displayItemsCount * 15}%` } }} />
            ) : (
                <BaseBreadcrumb
                    styles={styles || defaultStyles}
                    items={displayItems}
                    maxDisplayedItems={maxDisplayedItemsValue}
                    overflowIndex={displayItems.length > maxDisplayedItemsValue ? overflowIndexValue : undefined}
                    onRenderItem={onRenderItem}
                />
            )}
        </Stack>
    );
};

const defaultStyles: Partial<IBreadcrumbStyles> = {
    root: { margin: "auto" }
};

const limitTextLength = (text: string, maxLength?: number): string => `${text.slice(0, maxLength)}...`;
